import React, { Component } from 'react';

import FiberNew from '@mui/icons-material/FiberNew';

import styles from './styles.module.scss';

class FiberNewIcon extends Component {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    return <FiberNew className={styles.fiberNewIcon} />;
  }
}

export default FiberNewIcon;
